import React, { useState, useEffect } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import getMetadaAdobe from "../../utils/buttons/getMetadaAdobe";
import fixExportMogrt from "../../utils/buttons/fixExportMogrt";
import handleClick from "../../utils/handleClick.js";
import { getCachedScript } from "../../utils/scriptCache.js";

function ExportMogrtAdobe({
  onPopupStateChange,
  selectedTag,
  buttonTags,
  generateButtonTags,
}) {
  const [isVisible, setIsVisible] = useVisible("ExportMogrtAdobeVisibility");
  const [selectedCategory, setSelectedCategory] =
    useVisible("ExportMogrCategory");

  // сразу под импортами, до объявления компонента
  const categoryOptions = [
    { label: "Backgrounds", id: 10 },
    { label: "Infographics", id: 11 },
    { label: "Logo Reveals", id: 26 },
    { label: "Lower Thirds", id: 7 },
    { label: "Motion Effects", id: 30 },
    { label: "Motion Overlays", id: 31 },
    { label: "Slideshows", id: 38 },
    { label: "Titles", id: 40 },
    { label: "Transitions", id: 9 },
  ];

  useEffect(() => {
    if (onPopupStateChange) {
      onPopupStateChange(isVisible);
    }
  }, [isVisible]);

  // Убедитесь, что zipTemplate правильно обрабатывает и возвращает Promise

  // const handleClick = async (adobeStock) => {
  //   const code = getCachedScript();
  //   if (code) {
  //     try {
  //       const result = await fixExportMogrt(adobeStock);
  //     } catch (error) {
  //       //alert(error); // Обработка ошибки
  //     }
  //   }
  // };

  const handleHelp = (script, argument) => {
    const code = getCachedScript();
    if (code) {
      window.jsx.evalScript(`run(${script}(${argument}));`, function (result) {
        if (script.includes("Metadata")) {
          const data = JSON.parse(result);
          const names = data.names.map((item) => item.name);
          data.selectedCategory = selectedCategory;
          const prompt = `You will be given a list of project names typically used for stock video templates on marketplaces like Videohive or MotionArray.
Your task:
- For each name, generate a list of at least 20 relevant stock keywords (in English).
- Ignore numeric suffixes (like 01, 02, Part 1, Vol. 2, etc.).
- If multiple names share the same base name and differ only by numbering, return the same keyword list for all of them.
- Keywords should reflect the project's type, style, theme, and purpose.
- Do not include any text, code blocks, markdown formatting, or explanations.
- Only return a raw JSON array of keyword arrays, like:
[["keyword1", "keyword2", ...], ["keyword1", "keyword2", ...]]
Names:${JSON.stringify(names)}`;

          getMetadaAdobe(data, prompt);
        }
      });
    }
  };

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-download"></i>
        </div>
        <div className="button-card__title">Export Mogrt for Adobe Stock</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__checkbox-group">
          <div className="render-group__dropdown">
            <span className="render-group__dropdown-text">Category</span>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              {categoryOptions.map(({ label, id }) => (
                <option key={id} value={id}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="render-group__tools-grid">
          <div
            onClick={() => handleClick("exportMogrt", { adobeStock: true })}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-download"></i>
            <span>Export</span>
          </div>

          <div
            onClick={() => handleHelp("exportMediaPreviewMogrt", '"thumbnail"')}
            className="resolution-tools__button"
          >
            <i class="fa-sharp fa-regular fa-image"></i>
            <span>Thumbnail</span>
          </div>

          <div
            onClick={() => handleHelp("exportMediaPreviewMogrt", '"video"')}
            className="resolution-tools__button"
          >
            <i class="fa-sharp fa-light fa-film"></i>
            <span>Preview</span>
          </div>

          <div
            onClick={() => handleHelp("exportMogrtMetadata")}
            className="resolution-tools__button"
          >
            <i class="fa-light fa-database"></i>
            <span>Metadata</span>
          </div>

          <div
            onClick={() => handleHelp("createZipMogrt")}
            className="resolution-tools__button"
          >
            <i class="fa-sharp fa-light fa-file-zip"></i>
            <span>ZIP</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExportMogrtAdobe;
